import actionConsts from './../constants/actions';
import store from './../store/store';

const callRecieved = () => ({
    type: actionConsts.CALL_RECIEVED,
});

export const endCall = (payload) => {
    store.dispatch({
        type: actionConsts.END_CALL
    })
};

export const stopCallNotification = () => {
    store.dispatch(callRecieved());
}

export const incomingCallNotification = () => ({
    type: actionConsts.INCOMING_CALL_NOTIFICATION,
});


// WEBPACK FOOTER //
// /src/actions/call.js